import styled from 'styled-components';

const PostWritingTitleDiv = styled.div`
  padding-bottom: 32px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.12);
  padding-top: 8px;
`;

export default PostWritingTitleDiv;
